var _circle, _circle2, _circle3, _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCivCoin1(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 31,
    viewBox: "0 0 33 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 16.2797,
    cy: 15.4437,
    r: 15.4437,
    fill: "url(#paint0_linear_2877_9124)"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 16.2797,
    cy: 15.4437,
    r: 15.4077,
    stroke: "black",
    strokeOpacity: 0.12,
    strokeWidth: 0.0720721
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 17.393,
    cy: 15.4437,
    r: 15.4437,
    fill: "url(#paint1_linear_2877_9124)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_i_2877_9124)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.85194 19.144C9.20394 19.144 8.59994 19.04 8.03994 18.832C7.48794 18.616 7.00794 18.312 6.59994 17.92C6.19194 17.528 5.87194 17.068 5.63994 16.54C5.41594 16.012 5.30394 15.432 5.30394 14.8C5.30394 14.168 5.41594 13.588 5.63994 13.06C5.87194 12.532 6.19194 12.072 6.59994 11.68C7.01594 11.288 7.49994 10.988 8.05194 10.78C8.60394 10.564 9.20794 10.456 9.86394 10.456C10.5919 10.456 11.2479 10.584 11.8319 10.84C12.4239 11.088 12.9199 11.456 13.3199 11.944L12.0719 13.096C11.7839 12.768 11.4639 12.524 11.1119 12.364C10.7599 12.196 10.3759 12.112 9.95994 12.112C9.56794 12.112 9.20794 12.176 8.87994 12.304C8.55194 12.432 8.26794 12.616 8.02794 12.856C7.78794 13.096 7.59994 13.38 7.46394 13.708C7.33594 14.036 7.27194 14.4 7.27194 14.8C7.27194 15.2 7.33594 15.564 7.46394 15.892C7.59994 16.22 7.78794 16.504 8.02794 16.744C8.26794 16.984 8.55194 17.168 8.87994 17.296C9.20794 17.424 9.56794 17.488 9.95994 17.488C10.3759 17.488 10.7599 17.408 11.1119 17.248C11.4639 17.08 11.7839 16.828 12.0719 16.492L13.3199 17.644C12.9199 18.132 12.4239 18.504 11.8319 18.76C11.2479 19.016 10.5879 19.144 9.85194 19.144ZM17.1176 19L13.4936 10.6H15.5936L18.7616 18.04H17.5256L20.7416 10.6H22.6736L19.0376 19H17.1176ZM23.3749 19V10.6H25.3189V17.416H29.5309V19H23.3749Z",
    fill: "white",
    fillOpacity: 0.92
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_i_2877_9124",
    x: 5.30469,
    y: 10.457,
    width: 24.4428,
    height: 8.90372,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0.216216,
    dy: 0.216216
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.18018
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.03 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_2877_9124"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2877_9124",
    x1: 32.0198,
    y1: 6.62656,
    x2: 5.12371,
    y2: 26.5062,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.317708,
    stopColor: "#FFC843"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.505208,
    stopColor: "#F4D998"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.713542,
    stopColor: "#F8B106"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_2877_9124",
    x1: 1.83692,
    y1: 15,
    x2: 32.8369,
    y2: 15,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.09375,
    stopColor: "#C4C4C4",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.239583,
    stopColor: "#C4C4C4"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCivCoin1);
export default __webpack_public_path__ + "static/media/civ-coin-1.ff89668f4ab370509114d9b92a8f0143.svg";
export { ForwardRef as ReactComponent };